
import { Vue, Component, Prop } from 'vue-property-decorator'
import { setConnectivityTest } from '@/api/gcash/account'
import { AppModule } from '@/store/modules/app'

@Component({
  name: 'bulkLogin',
  components: {}
})
export default class extends Vue {
  @Prop({ required: true }) list!: any

  get language() {
    return AppModule.language
  }

  private loading: boolean = false
  private back() {
    this.$emit('close')
  }

  private idList: any = []
  getDeteleId() {
    this.list.forEach(item => {
      this.idList.push(item.phone_number)
    })
  }

  private async create() {
    this.getDeteleId()
    if (this.language === 'en') {
      this.$confirm('Please confirm whether to open the current account?', {
        confirmButtonText: 'Yes',
        cancelButtonText: 'Cancel',
        type: 'warning',
        callback: action => {
          let data: any = {
            action: 'batch_login ',
            data: {
              msisdn_list: this.idList
            }
          }
          if (action === 'confirm') {
            setConnectivityTest(data).then(() => {
              this.$message({
                type: 'success',
                message: 'Successful transfer!'
              })
              this.back()
            })
          }
        }
      })
    } else if (this.language === 'zh_cn') {
      this.$confirm('请确认是否开启当前账户?', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning',
        callback: action => {
          let data: any = {
            action: 'batch_login ',
            data: {
              msisdn_list: this.idList
            }
          }
          if (action === 'confirm') {
            setConnectivityTest(data).then(() => {
              this.$message({
                type: 'success',
                message: 'Successful transfer!'
              })
              this.back()
            })
          }
        }
      })
    } else if (this.language === 'zh_tw') {
      this.$confirm('請確認是否開啟當前賬戶?', {
        confirmButtonText: '確認',
        cancelButtonText: '取消',
        type: 'warning',
        callback: action => {
          let data: any = {
            action: 'batch_login ',
            data: {
              msisdn_list: this.idList
            }
          }
          if (action === 'confirm') {
            setConnectivityTest(data).then(() => {
              this.$message({
                type: 'success',
                message: 'Successful transfer!'
              })
              this.back()
            })
          }
        }
      })
    }
  }

  mounted() {}
}
